import { useTheme } from "@emotion/react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  currencyFormat,
  currencyFormatNoDecimals,
} from "../../../../../../components/NewDetail/calculations/utils";

const Coil = (props) => {
  const { coil } = props;
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  if (!coil) return null;

  return (
    <Box {...props}>
      <Typography variant="h6">
        Coil -{" "}
        {currencyFormatNoDecimals(
          Math.round(
            parseFloat(
              coil &&
                coil.coilCalculations &&
                coil.coilCalculations.totalSellPrice
                ? coil.coilCalculations.totalSellPrice
                : 0.0
            )
          )
        )}
      </Typography>
      <TableContainer component={Box} sx={{ marginTop: "8px" }}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Width (in.)</TableCell>
              <TableCell align="right">Lineal Feet Of Coil</TableCell>
              <TableCell align="right">Square Foot Pricing</TableCell>
              <TableCell align="right">Lineal Foot Pricing</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {coil.width}
              </TableCell>
              <TableCell align="right">{coil.linealFeet}</TableCell>
              <TableCell align="right">
                {currencyFormat(coil.pricePerSquareFeetOfCoil ?? 0)}
              </TableCell>
              <TableCell align="right">
                {currencyFormat(coil.pricePerLinealFootOfCoil ?? 0)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Coil;
